import { useContentStore } from '@/stores/content'
import { computed, isRef, type Ref } from 'vue'

export function useWidgetText(slug: string, role?: Ref<string | undefined> | string) {
  const contentStore = useContentStore()

  const resolvedRole = computed(() => (isRef(role) ? role.value : role))

  /** Get a CMS widget text by path parts. Returns '' if not yet loaded. */
  function wt(...path: string[]): string {
    return contentStore.getWidgetText(slug, resolvedRole.value, ...path) ?? ''
  }

  function wtValue(...path: string[]): unknown {
    return contentStore.getWidgetTextValue(slug, resolvedRole.value, ...path)
  }

  return { wt, wtValue }
}
